import { render, staticRenderFns } from "./HowToConsignmentPage.vue?vue&type=template&id=243e4ab7&scoped=true&"
import script from "./HowToConsignmentPage.vue?vue&type=script&lang=js&"
export * from "./HowToConsignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243e4ab7",
  null
  
)

export default component.exports